import React, { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { ValidationSummary, ValidationForm, ValidatingInput } from '@/components/forms/validation';
import { changePassword } from '@/services/users';
import { Button } from '@/components/Buttons';
import { useValidationManager } from '@/utils/hooks';
import { Toast } from '@ygtechnologies/bygr-frontend-component-library';

const ChangePassword: React.FC<{}> = () => {
    const [saving, setSaving] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const validationManager = useValidationManager([
        {
            isValid: (value, options) => newPassword === confirmPassword,
            message: ({ field }) => <Trans>Passwords must match</Trans>,
            summaryMessage: ({ field }) => <Trans>Passwords must match</Trans>,
        },
    ]);

    const reset = () => {
        setConfirmPassword('');
        setCurrentPassword('');
        setNewPassword('');
    };

    const onSave = async (e) => {
        e.preventDefault();
        setSaving(true);

        try {
            await changePassword(currentPassword, newPassword);

            setIsEdit(false);
            Toast.success(<Trans>Password updated successfully</Trans>);
            reset();
        } finally {
            setSaving(false);
        }
    };

    if (!isEdit) {
        return (
            <>
                <h5>
                    <Trans>Password</Trans>
                    <Button size="xsmall" color="link" onClick={(e) => setIsEdit(true)}>
                        <Trans>Change</Trans>
                    </Button>
                </h5>
                <div className="form columns-1 labels-25">
                    <label>
                        <Trans>Password</Trans>
                        <input value={'********'} className="form-control-plaintext" disabled />
                    </label>
                </div>
            </>
        );
    }

    return (
        <>
            <h5>
                <Trans>Password</Trans>
            </h5>
            <ValidationForm validationManager={validationManager} onSubmit={onSave} className="form columns-1 labels-25">
                <div>
                    <label>
                        <Trans>Current password</Trans>
                        <ValidatingInput
                            placeholder={t`Current password`}
                            required
                            type="password"
                            className="form-control"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            autoFocus
                        />
                    </label>
                </div>
                <div>
                    <label>
                        <Trans>New password</Trans>
                        <ValidatingInput
                            placeholder={t`New password`}
                            required
                            type="password"
                            className="form-control"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </label>
                </div>
                <div>
                    <label>
                        <Trans>Confirm password</Trans>
                        <ValidatingInput
                            placeholder={t`Confirm password`}
                            required
                            type="password"
                            className="form-control"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                    </label>
                </div>

                <div className="label-offset">
                    <ValidationSummary />
                </div>

                <div className="buttons">
                    <Button
                        color="tertiary"
                        disabled={saving}
                        onClick={(e) => {
                            reset();
                            setIsEdit(false);
                        }}>
                        <Trans>Cancel</Trans>
                    </Button>

                    <Button type="submit" color="primary" loading={saving}>
                        <Trans>Change password</Trans>
                    </Button>
                </div>
            </ValidationForm>
        </>
    );
};
export default ChangePassword;
